<form [formGroup]="formGroup" class="tw-flex tw-flex-col tw-gap-4 tw-py-4">
  <app-input
    [label]="'groceryListName' | i18n"
    [isRequired]="true"
    [placeholder]="'groceryListNamePlaceholder' | i18n"
    [manualTouched]="formGroup.get('name').touched"
    formControlName="name"
    testId="rename-list-input"
    class="tw-w-full"
  ></app-input>

  <div class="tw-flex tw-justify-end tw-gap-4 tw-mt-2">
    <app-gloss-button
      [options]="{
        text: 'save' | i18n,
        fullClass: 'btn-primary-teal',
        type: 'submit',
        isEnabled: true,
        onClick: submit.bind(this),
      }"
      [isLoading]="submitting"
      class="sm:tw-w-full tw-w-1/2"
      fontClass="!tw-font-bold tw-text-[16px] tw-text-dt-slate-0"
    ></app-gloss-button>
  </div>
</form>
